module.exports = __webpack_public_path__ + "img/ESG_KK_cover_mobil.046b535a.jpg";